import comp from '../components/barrel';
import listReturnState from '../js/listReturnState';

const EP = 'advisors/get-advisor-details';

function cellText(val) {
  return val != null && String(val).trim() !== '' ? String(val) : '';
}

function ynText(val) {
  if (val === true) return 'Yes';
  if (val === false) return 'No';
  return '—';
}

function parseDateOnly(val) {
  if (val == null || String(val).trim() === '') return null;
  const m = String(val).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const d = new Date(val);
  if (Number.isNaN(d.getTime())) return null;
  d.setHours(0, 0, 0, 0);
  return d;
}

function styleOverdueCrmFollowUp(el, crmFollowUp, lastContactReport) {
  const crm = parseDateOnly(crmFollowUp);
  const lastContact = parseDateOnly(lastContactReport);
  if (!crm || !lastContact || !el) return;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (crm < today && lastContact < crm) {
    el.classList.add('font-bold');
    el.style.color = '#dc2626';
  }
}

async function dateText(val) {
  if (val == null || String(val).trim() === '') return '—';
  return await U.formatDate(val);
}

function marketerName(row) {
  return `${cellText(row.marketer_f_name)} ${cellText(row.marketer_s_name)}`.trim();
}

function renderApplicationBreakdown(counts) {
  const card = U.id('applicationBreakdownCard');
  const host = U.id('applicationBreakdown');
  if (!card || !host) return;
  host.innerHTML = '';
  const rows = Array.isArray(counts) ? counts : [];
  if (!rows.length) {
    card.hidden = true;
    return;
  }
  card.hidden = false;
  const grid = U.divAtt('div', 'class', 'application-breakdown-grid');
  rows.forEach((row) => {
    const status = document.createElement('p');
    status.textContent = cellText(row && row.status) || '—';
    const count = document.createElement('p');
    count.textContent = row && row.count != null && String(row.count).trim() !== '' ? String(row.count) : '—';
    grid.appendChild(status);
    grid.appendChild(count);
  });
  host.appendChild(grid);
}

export default {
  async prepare() {},

  async render() {
    await this.loadPage();
  },

  openManageUser() {
    const uuid =
      (thsPage && thsPage.vars && thsPage.vars.advisor_uuid) ||
      (thsPage && thsPage.advisorDetails && thsPage.advisorDetails.advisor_uuid) ||
      (this.vars && this.vars.advisor_uuid) ||
      '';
    if (!uuid) return;
    if (thsPage && thsPage.listReturnBack) {
      listReturnState.save('ViewAdvisor', thsPage.listReturnBack);
    }
    listReturnState.save('ViewUser', {
      listPage: 'ViewAdvisor',
      state: {advisor_uuid: uuid},
    });
    O.PREP('ViewUser', `target_user_uuid=${uuid}`);
  },

  async loadPage() {
    const form = U.id('advisorDetailsForm');
    if (!form) return;
    form.innerHTML = '';
    renderApplicationBreakdown([]);

    let details = thsPage && thsPage.advisorDetails;
    if (!details) {
      const advisor_uuid =
        (this.vars && this.vars.advisor_uuid) ||
        (thsPage && thsPage.vars && thsPage.vars.advisor_uuid) ||
        '';
      if (!advisor_uuid) {
        const p = U.divAtt('p', 'class', 'text-gray-600');
        p.textContent = 'No advisor selected. Open an advisor from the list.';
        form.appendChild(p);
        return;
      }
      const res = await O.PREP([await O.mPOST(EP, {advisor_uuid})]);
      const detailsRes = res[EP] || {};
      if (detailsRes.status === 'OK') {
        details = detailsRes.data || null;
        if (thsPage) thsPage.advisorDetails = details;
      } else {
        const p = U.divAtt('p', 'class', 'text-gray-600');
        p.textContent = (detailsRes.data && detailsRes.data.error) || 'Unable to load advisor details';
        form.appendChild(p);
        return;
      }
    }

    if (!details) {
      const p = U.divAtt('p', 'class', 'text-gray-600');
      p.textContent = (thsPage && thsPage.advisorDetailsError) || 'Advisor not found.';
      form.appendChild(p);
      return;
    }

    const grid = U.divAtt('div', 'class', 'res-grid-cols-3');
    grid.appendChild(comp.displayText('advisorFName', cellText(details.advisor_f_name) || '—', 'First name'));
    grid.appendChild(comp.displayText('advisorSName', cellText(details.advisor_s_name) || '—', 'Last name'));
    grid.appendChild(comp.displayText('advisorBroker', cellText(details.broker_number) || '—', 'Broker number'));
    grid.appendChild(comp.displayText('advisorEmail', cellText(details.email_address) || '—', 'Email'));

    const activeWrap = U.divAtt('div', 'class', 'input-group');
    const isActive = details.active_yn === true || details.active_yn === 'true' || details.active_yn === 1;
    activeWrap.appendChild(await comp.statusTag(isActive ? 'Active' : 'Inactive'));
    grid.appendChild(activeWrap);

    grid.appendChild(comp.displayText('advisorRetired', ynText(details.retired_yn), 'Retired'));
    grid.appendChild(
      comp.displayText('advisorLastContact', await dateText(details.last_contact_report), 'Last contact report')
    );

    const crmField = comp.displayText(
      'advisorCrmFollowUp',
      await dateText(details.crm_follow_up),
      'CRM follow up'
    );
    const crmValue = crmField.querySelector('#advisorCrmFollowUp');
    styleOverdueCrmFollowUp(crmValue, details.crm_follow_up, details.last_contact_report);
    grid.appendChild(crmField);

    grid.appendChild(comp.displayText('advisorOrg', cellText(details.orgname) || '—', 'Organisation'));
    grid.appendChild(comp.displayText('advisorOrgBranch', cellText(details.orgbranch) || '—', 'Org. branch'));
    grid.appendChild(comp.displayText('advisorRole', cellText(details.role) || '—', 'Role'));
    grid.appendChild(comp.displayText('advisorMarketer', marketerName(details) || '—', 'Marketer'));
    grid.appendChild(
      comp.displayText(
        'advisorLatestApplication',
        await dateText(details.latest_application_created_date),
        'Latest application / Will'
      )
    );

    form.appendChild(grid);
    renderApplicationBreakdown(details.application_status_counts);
  },
};
